import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NoConvSelected from '../../components/messenger/NoConvSelected'
import Conversations from '../../components/messenger/Conversations'
import { useNavigate, useLocation  } from 'react-router-dom'
import styled from 'styled-components' 
import Sidebar from 'components/Sidebar'
import useGetWindowSize from 'hooks/useGetWindowSize'
import { logoutUser, resetUserForLogout } from 'features/auth/authSlice'
import { addAc } from 'features/auth/authSlice'
import { addAcFunc } from 'funcs/ac'
import { PageContainerMain } from 'pages/pages.styled'

function Messenger() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { id, fullName } = location.state ?? 'none'
    const { user } = useSelector(state => state.auth )
    const { isConversationsError, conversationsErrorMessage, isCreateConversationSuccess, alreadyExists, alreadyExistsId, newConversation } = useSelector(state => state.conversations)
    const [width, height] = useGetWindowSize()


    useEffect(() => {

        if(isConversationsError && conversationsErrorMessage === 'Not logged in') {
            dispatch(logoutUser())
            dispatch(resetUserForLogout())
            navigate('/login')
            window.location.reload(false);
            
        } else if(id && id !== user._id){

            if(isCreateConversationSuccess && alreadyExists){
                // dispatch(chooseConversation({id: alreadyExistsId, fullName: data.fullName}))
                navigate(`/messages/${alreadyExistsId}`, {replace: true})

            }else if( isCreateConversationSuccess && !alreadyExists && newConversation ){
                navigate(`/messages/${newConversation}`, {replace: true})
            }
        }
    }, [ dispatch, alreadyExists, alreadyExistsId, id, isCreateConversationSuccess, navigate, newConversation, user, isConversationsError, conversationsErrorMessage ])
    
    useEffect(() => {

        const dis = () => dispatch(addAc({
          type: 'messages', 
        }))
    
        addAcFunc('messages', dis)
    
    }, [])


    return (
        <PageContainerMain> 
            <Sidebar />

            <Conversations /> 

            {
                width >= 768 && (
                    <MessagesWrap>
                        < NoConvSelected /> 
                    </MessagesWrap>         
                )
            }  
        </PageContainerMain>
    )
}

export default Messenger



const MessagesWrap = styled.div`
    width: 700px; 
    min-width: 550px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: flex-start; 
    height: 100%; 

`